import * as type from "../types/registration";

const initialState = {
  validateGeneral: {
    status: null,
    loading: false,
    error: null,
    id: null,
  },
  validateLastStep: {
    status: null,
    loading: false,
    error: null,
  },
  checkCanRegister: {
    status: null,
    loading: false,
    error: null,
  },
  validateInviteRegister: {
    status: null,
    loading: false,
    error: null,
  },
};

export const registration = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_GENERAL_VERIFICATION:
      return {
        ...state,
        validateGeneral: {
          ...state.validateGeneral,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_GENERAL_VERIFICATION:
      return {
        ...state,
        validateGeneral: {
          ...state.validateGeneral,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_GENERAL_VERIFICATION:
      return {
        ...state,
        validateGeneral: {
          ...state.validateGeneral,
          status: "success",
          loading: false,
          error: null,
          id: payload.data,
        },
      };
    case type.RESET_GENERAL_VERIFICATION:
      return {
        ...state,
        validateGeneral: {
          ...state.validateGeneral,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_FINALIZE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_FINALIZE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_FINALIZE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_FINALIZE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_CAN_REGISTER:
      return {
        ...state,
        checkCanRegister: {
          ...state.checkCanRegister,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_CAN_REGISTER:
      return {
        ...state,
        checkCanRegister: {
          ...state.checkCanRegister,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_CAN_REGISTER:
      return {
        ...state,
        checkCanRegister: {
          ...state.checkCanRegister,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_CAN_REGISTER:
      return {
        ...state,
        checkCanRegister: {
          ...state.checkCanRegister,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_INVITATION_REGISTRATION:
      return {
        ...state,
        validateInviteRegister: {
          ...state.validateInviteRegister,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_INVITATION_REGISTRATION:
      return {
        ...state,
        validateInviteRegister: {
          ...state.validateInviteRegister,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_INVITATION_REGISTRATION:
      return {
        ...state,
        validateInviteRegister: {
          ...state.validateInviteRegister,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_INVITATION_REGISTRATION:
      return {
        ...state,
        validateInviteRegister: {
          ...state.validateInviteRegister,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_NEW_SPACE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_NEW_SPACE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_NEW_SPACE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_NEW_SPACE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_RESUBSCRIBE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_RESUBSCRIBE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_RESUBSCRIBE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_RESUBSCRIBE_REGISTRATION:
      return {
        ...state,
        validateLastStep: {
          ...state.validateLastStep,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
